document.querySelector('#search-button')?.addEventListener('click',()=>{const p=document.querySelector('#search-panel');p.hidden=!p.hidden;if(!p.hidden)document.querySelector('#search').focus()});document.querySelector('#menu-button')?.addEventListener('click',()=>{let p=document.querySelector('#mobile-menu');p.hidden=!p.hidden});document.querySelectorAll('[data-size-guide]').forEach(b=>b.addEventListener('click',()=>document.querySelector('#size-dialog').showModal()));document.querySelector('#size-dialog .close')?.addEventListener('click',()=>document.querySelector('#size-dialog').close());document.querySelector('#track-form')?.addEventListener('submit',e=>{e.preventDefault();const d=new FormData(e.target);location.href='mailto:support@soleharbour.co.uk?subject='+encodeURIComponent('Tracking enquiry '+d.get('order'))+'&body='+encodeURIComponent('Order email: '+d.get('email'))});
document.addEventListener('change',event=>{if(!event.target.matches('.product-page .sh-size-picker input[name="id"]'))return;const url=new URL(location.href);url.searchParams.set('variant',event.target.value);history.replaceState({},'',url)});

document.addEventListener('submit',event=>{
const button=event.submitter;
if(!button?.matches('[data-sh-buy-now]'))return;
event.preventDefault();
const form=event.target;
if(!form.reportValidity())return;
const data=new FormData(form);
const variant=String(data.get('id')||'');
const quantity=Number(data.get('quantity')||1);
if(!/^\d+$/.test(variant)||!Number.isInteger(quantity)||quantity<1)return;
const cartPath=button.dataset.cartUrl.replace(/\/$/,'');
window.location.assign(cartPath+'/'+variant+':'+quantity);
});

document.addEventListener('click',async event=>{
const button=event.target.closest('[data-sh-discount-apply],[data-sh-discount-clear]');
if(!button)return;
const root=button.closest('[data-sh-cart]');
if(root.dataset.busy==='true')return;
const input=root.querySelector('#Cart-discount');
const status=root.querySelector('.sh-cart-code-status');
const clear=button.hasAttribute('data-sh-discount-clear');
const code=clear?'':input.value.trim();
if(!clear&&!code){status.textContent=root.dataset.codeEmpty;input.focus();return;}
const form=button.closest('form');
if(!form.reportValidity())return;
const controls=[...root.querySelectorAll('button')];
root.dataset.busy='true';root.setAttribute('aria-busy','true');controls.forEach(control=>control.disabled=true);
let freshRoot=root;
try{
const updates={};
root.querySelectorAll('[data-line-key]').forEach(field=>updates[field.dataset.lineKey]=Number(field.value));
const response=await fetch(root.dataset.updateUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:code,updates,sections:[root.dataset.sectionId],sections_url:location.pathname})});
const data=await response.json();
if(!response.ok)throw new Error(data.description||data.message);
const html=data.sections?.[root.dataset.sectionId];
if(html){const doc=new DOMParser().parseFromString(html,'text/html');const next=doc.querySelector('[data-sh-cart]');if(next){root.replaceWith(next);freshRoot=next;}}
else{throw new Error(root.dataset.cartError);}
const badge=document.querySelector('#bag-count');
if(badge)badge.textContent=String(data.item_count);
const result=freshRoot.querySelector('.sh-cart-code-status');
const newInput=freshRoot.querySelector('#Cart-discount');
if(newInput)newInput.value=code;
const entry=data.discount_codes?.find(item=>item.code.toLowerCase()===code.toLowerCase());
const allocations=[...(data.cart_level_discount_applications||[]),...(data.items||[]).flatMap(item=>(item.line_level_discount_allocations||[]).map(a=>a.discount_application))];
const applied=entry?.applicable===true||allocations.some(a=>a.type==='discount_code'&&a.title.toLowerCase()===code.toLowerCase());
if(result)result.textContent=clear?root.dataset.codeRemoved:applied?root.dataset.codeApplied:entry?.applicable===false?root.dataset.codeInvalid:root.dataset.codeCheckout;
newInput?.focus();
}catch(error){const target=freshRoot.querySelector('.sh-cart-code-status');if(target)target.textContent=root.dataset.cartError;}
finally{delete freshRoot.dataset.busy;freshRoot.removeAttribute('aria-busy');if(freshRoot===root)controls.forEach(control=>control.disabled=false);}
});
document.addEventListener('keydown',event=>{
if(event.key!=='Enter'||!event.target.matches('#Cart-discount'))return;
event.preventDefault();event.target.closest('[data-sh-cart]').querySelector('[data-sh-discount-apply]').click();
});
